import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

var alertsService;
export default function() { // lazy initialization. we export function which returns servies. this way service will be created only when it will be really necessary

    // model
    var AlertsModel = Model.extend({
        className: "Alerts",
        defaults: {
            'manualTitle': false,
        },

    });

    // collection
    var AlertsCollection = Collection.extend({
        model: AlertsModel
    });

    // service (extends ParseService)
    var ReportCategoryService = ParseService.extend({
        sortBy: 'createdAt',
        model: AlertsModel,
        collection: AlertsCollection,
        SetAlert: function(id){
			this.fetch({
				all: true,
				cache: false,
				rules: {
					equals: [{
						key: 'report',
						val:  { __type: "Pointer", className: "Report", objectId: id }
					}]
				}
			}).then(report => {
				if(report.models.length>0){
					report.models[0].parseObject.set('alert',true);
					report.models[0].parseObject.save();
				}
				else {
					var model = new this.model("Alerts");
					model.set('report',{ __type: "Pointer", className: "Report", objectId: id });
					model.set('alert',true);
					return model.save();
				}
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
        }
        // you can also extend any method from ParseService here
    });

    return alertsService || (alertsService = new ReportCategoryService());
};
// only created once for application
